import { useState, useEffect, useRef, } from "react";
import React from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import Wrapper from "../../components/UI/Wrapper";
import filterIcon from "../../Icons/filterIcon.png";
import ReimbursedIcon from "../../Icons/Reimbursed.png";
import PettyCashIcon from "../../Icons/PettyCash.png";
import BalanceIcon from "../../Icons/Balance.png";
import SearchIcon from "@mui/icons-material/Search";
import CryptoJS from 'crypto-js';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const PettyCashDetail = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [pettyCashId, setPettyCashId] = useState("");
  const [userdetail, setUserdetail] = useState("");
  const storedToken = JSON.parse(localStorage.getItem("token"));
 
  const [formData, setFormData] = useState([]);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  useEffect(() => {
    const encryptedId = query.get('id');
    if (encryptedId) {
      const bytes = CryptoJS.AES.decrypt(encryptedId, 'dbbworldwidepvtltd');     
      setPettyCashId(bytes.toString(CryptoJS.enc.Utf8));
      fetchPettyCashDetails(bytes.toString(CryptoJS.enc.Utf8));     
      fetchPettyCashList(bytes.toString(CryptoJS.enc.Utf8));
    }
  }, []);

  const fetchPettyCashDetails = async (pettycash_id) => {    
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const pcDetailRes = await axios.get(`${baseAPI}userGet/getUserDetailForPettyCash?pettycash_id=${pettycash_id}`, { headers });
      setUserdetail(pcDetailRes.data.data[0]);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const getRemainingBalanceColor = (balance) => {
    const newBalance = Number(balance);
    if (newBalance > 0) {
      return "#20BF44";
    } else {
      return "#DC3545";
    }
  };

  const fetchPettyCashList = async (pettycash_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const pcDetailRes = await axios.get(`${baseAPI}userGet/GetPettyCashDetail?pettycash_id=${pettycash_id}&relocation_id=0`, { headers });
      setFormData(pcDetailRes.data.data[0]);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddPettyCash = async (e) => {
    e.preventDefault();
    if (!formData.expense_type || !formData.amount) {
      alert("Please fill all required fields");
      return;
    }
    
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`, // Replace with your token logic
        "Content-Type": "application/json",
      };

      const response = await axios.post(`${baseAPI}UserPost/InsertUpdateCmpPettyCash`, formData, { headers });

      if (response.status === 200) {
        toast.success("Receipt has been uploaded", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

      } else {
        console.error("Unexpected response:", response);
        alert("Error saving expense!");
      }
    } catch (error) {
      console.error("Error saving expense:", error.response ? error.response.data : error.message);
      alert("Error saving expense!");
    }
  };





  return (
    <div>
      <div className="app-container-viewLeadDetails">
        <MiniDrawer />
        <div className="container-fluid container-viewLeadDetails">
          <div className="country-header">
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                <b> Petty Cash Details </b> | <HomeOutlinedIcon /> &gt; Accounts
                & Finance{" "}
                <span style={{ fontSize: "20px" }}>&gt; Petty Cash</span>
                <span style={{ fontSize: "20px" }}>
                  &gt; Petty Cash Details
                </span>
              </h1>
            </div>
          </div>
          <Wrapper className="LeadDetails">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <b style={{ textDecoration: "underline" }}>
                  {userdetail.Department} ({userdetail.name})
                </b>
              </div>
              <div>
                <button>LIST</button>
              </div>
            </div>
          </Wrapper>
          <br />
         
         
          {/* ------------------------lead deatil--------------------- */}
          <Wrapper className="LeadDetails">
            <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Request Detail </span>
                  </th>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Name</span>
                  </th>
                  <td>
                    <span>{userdetail.name}</span>
                  </td>
                  <th>
                    <span>Department</span>
                  </th>
                  <td>
                    <span>{userdetail.Department}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Designation</span>
                  </th>
                  <td>
                    <span>{userdetail.Designation}</span>
                  </td>
                  <th>
                    <span>Date of Request</span>
                  </th>
                  <td>
                    <span>{userdetail.request_date}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Expense Type</span>
                  </th>
                  <td>
                    <span>{userdetail.expense_type}</span>
                  </td>
                  <th>
                    <span>Fixed Amount</span>
                  </th>
                  <td>
                    <span>{userdetail.fixed_amount}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Requested Amount</span>
                  </th>
                  <td>
                    <span>{userdetail.amount}</span>
                  </td>
                  <th>
                    <span>Remaining Amount</span>
                  </th>
                  <td>
                    <span>{userdetail.remaining_amount}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Account Number</span>
                  </th>
                  <td>
                    <span>{userdetail.account_number}</span>
                  </td>
                  <th>
                    <span>IFSC</span>
                  </th>
                  <td>
                    <span>{userdetail.ifsc}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Manager's Name</span>
                  </th>
                  <td>
                    <span>{userdetail.manager}</span>
                  </td>
                  <th>
                    <span>Manager's Approval</span>
                  </th>
                  <td>
                    <span>{userdetail.manager_approval}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />

            <div
              style={{
                width: "100%",
                alignItems: "center",
                display: "none",
              }}
            >
              <table className="customerDetailsTable">
                <div className="undefined" style={{ width: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        padding: "11px 0 0 0",
                        overflowX: "auto",
                      }}
                    >
                      <table>
                        <tr className="docUpload">
                          <th
                            style={{ width: "5%", border: "1px solid #DEE2E6" }}
                          >
                            Sr No.
                          </th>
                          <th
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Voucher Number
                          </th>
                          <th
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Date
                          </th>
                          <th
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Name
                          </th>
                          <th
                            style={{
                              width: "25%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Cash Received
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Description
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Amount
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Remaining Balance
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Remark(if any)
                          </th>
                          <th
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Related Document
                          </th>
                        </tr>

                        <tr className="documentTable">
                          <td
                            style={{ width: "5%", border: "1px solid #DEE2E6" }}
                          >
                            1
                          </td>
                          <td
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            0000
                          </td>
                          <td
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            12 Dec 2024
                          </td>
                          <td
                            style={{
                              width: "20%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            Antara
                          </td>
                          <td
                            style={{
                              width: "25%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            2000
                          </td>

                          <td
                            style={{
                              width: "10%",
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            test
                          </td>
                          <td style={{ border: "1px solid #DEE2E6" }}>₹ 990</td>
                          <td
                            style={{
                              color: getRemainingBalanceColor("1000"),
                              border: "1px solid #DEE2E6",
                            }}
                          >
                            ₹ 1000
                          </td>
                          <td style={{ border: "1px solid #DEE2E6" }}>
                            ......
                          </td>
                          <td style={{ border: "1px solid #DEE2E6" }}>
                            <button
                              // onClick={() => nextPage()}
                              style={{
                                height: "30px",
                                width: "38px",
                                backgroundColor: "#E3DCFF",
                                border: "1px solid #E3DCFF",
                              }}
                            >
                              <SearchIcon
                                className="icon"
                                style={{ color: "#5B489D", border: "none" }}
                              />
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </table>
              <div
                style={{ backgroundColor: "#F0F0F0" }}
                className="text-end p-0"
              >
                <h6
                  className=" px-3"
                  style={{
                    paddingTop: "16px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}
                >
                  Total Reimbursed :{" "}
                  <span style={{ color: "#6A6A6A", fontWeight: "700" }}>
                    ₹ 2,000.00
                  </span>
                </h6>
                <hr className="" style={{ padding: "0px 0px 0px 10px" }} />
                <h6
                  className=" px-3"
                  style={{
                    paddingBottom: "20px",
                    fontWeight: "600",
                    color: "#6A6A6A",
                  }}
                >
                  Total Amount Used :{" "}
                  <span style={{ color: "#6A6A6A", fontWeight: "700" }}>
                    ₹ 2,000.00
                  </span>
                </h6>
              </div>
            </div>
          </Wrapper>
          <br />
          <Wrapper className="ViewLeadDetails">
          <div className="viewLeadDetails-form">
              <table
                style={{
                  width: "100%",
                  color: "#6A6A6A",
                  borderRadius: "5px",
                }}
              >
                <tr className="viewLeadDetailsHeading">
                  <th
                    colSpan={4}
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}> Payment Detail </span>
                  </th>
                </tr>
                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Signatory Name</span>
                  </th>
                  <td>
                    <span>{formData.approved_by_name}</span>
                  </td>
                  <th>
                    <span>Date of Approval</span>
                  </th>
                  <td>
                    <span>{formData.approval_date}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Payment Status</span>
                  </th>
                  <td>
                    <span>{formData.approval_status}</span>
                  </td>
                  <th>
                    <span>Amount</span>
                  </th>
                  <td>
                    <span>{formData.amount}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Payment Mode</span>
                  </th>
                  <td>
                    <span>{formData.payment_mode}</span>
                  </td>
                  <th>
                    <span>Expense Category</span>
                  </th>
                  <td>
                    <span>{formData.expense_type_name}</span>
                  </td>
                </tr>

                <tr className="viewLeadDetailsHeading">
                  <th>
                    <span>Related Document</span>
                  </th>
                  <td>
                    <span>{formData.attachment}</span>
                  </td>
                  <th>
                    <span>Remark (If Any)</span>
                  </th>
                  <td>
                    <span>{formData.approval_remark}</span>
                  </td>
                </tr>               
              </table>
            </div>
          </Wrapper>
          <br />
        </div>
      </div>
    </div>
  );
};

export default PettyCashDetail;
